<div class="filter-sort-container new-case">
    <filter-sort
        [endpoint]="searchEndpoint"
        [searchPlaceholder]="'Search Clients'"
        [dialogOption]="true"
        [searchType]="searchTypeEnum.Simple">
    </filter-sort>
    <mat-divider></mat-divider>
</div>

<ng-container
    *ngIf="{
        data: data$ | async,
        searchActive: searchActive$ | async,
        filtersActive: filtersActive$ | async,
        dataLoading: dataLoading$ | async
    } as data">
    <ng-container *ngIf="!data.dataLoading; else loading">
        <ng-container *ngIf="data.data?.length > 0; else noData">
            <div
                infiniteScroll
                [infiniteScrollContainer]="'.listing-wrapper'"
                [fromRoot]="true"
                (scrolled)="onScrollDownThreshold()"
                [infiniteScrollThrottle]="50"
                [infiniteScrollDistance]="2">
                <app-new-case-search-clients-header></app-new-case-search-clients-header>

                <div>
                    <div class="listing-wrapper new-case">
                        <app-new-case-search-clients-card
                            *ngFor="let client of data.data"
                            [client]="client"
                            (clientSelected)="getSelectedClient($event)">
                        </app-new-case-search-clients-card>
                    </div>
                </div>
            </div>
        </ng-container>

        <ng-template #noData>
            <app-search-empty-state
                [filterOption]="filterOptionEnum.Clients"
                [emptyResult]="
                    !data.filtersActive && !data.searchActive ? false : true
                "
                [dialogOption]="true">
            </app-search-empty-state>
        </ng-template>
    </ng-container>
</ng-container>

<ng-template #loading>
    <div class="spinner-container default-spinner new-case">
        <mat-spinner></mat-spinner>
    </div>
</ng-template>
